<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [searchText]="searchText"
   [pagingCallState]="pagingCallState"
   [showCreate]="rolePrivileges?.canAdd"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="name" width="3">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="role-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Asc"
               sortField="name"
               >Role<mat-icon class="mat-icon-sort">{{ getSort('name') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let role">
               <a [routerLink]="getRouterLink(role.roleId)">
                  {{ role.name }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="description" width="6">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="description-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="description"
               >Description<mat-icon class="mat-icon-sort">{{ getSort('description') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let role">
               <a [routerLink]="getRouterLink(role.roleId)">
                  {{ role.description }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="roleUserCount" width="2">
            <th
               lcs-header-cell
               *lcsHeaderCellDef
               id="roleUserCount-column-header"
               class="register-column-header numeric"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="userRolesCount"
               >User Count<mat-icon class="mat-icon-sort">{{ getSort('userRolesCount') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let role" class="numeric">
               <a [routerLink]="getRouterLink(role.roleId)">
                  {{ role.roleUserCount }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="systemRoleActionsMenu" width="1">
            <th lcs-header-cell *lcsHeaderCellDef id="system-role-actions-menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let role">
               <button
                  type="button"
                  aria-label="Role Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="systemRolesMenu"
                  id="system-role-more-actions"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               <mat-menu #systemRolesMenu="matMenu">
                  <a mat-menu-item [routerLink]="getRouterLink(role.roleId)"> Details </a>
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
